import React from 'react';
import './CSS/Vision.css';
import visionImage from '../assets/images/promise.png';
import tickIcon from '../assets/icons/tick.png';

const OurPromise = () => {
  const visionPoints = [
    "No tech jargon, no stress — just clear solutions and good vibes.",
    "You’ll always get more than you expect.",
    "Every visitor is valued, every issue matters.",
    "Whether it’s a quick fix or a big repair, we’re here to help."
  ];

  return (
    <section className="vision-section">
      <div className="container">
        <div className="vision-content">
          {/* Left Column - Image */}
          <div className="vision-left">
            <div className="vision-image">
              <img src={visionImage} alt="Our Vision" />
            </div>
          </div>

          {/* Right Column - Content */}
          <div className="vision-right">
            <div className="vision-text-content">
              <h2 className="vision-title">
                Our <span className="text-primary">Promise</span>
              </h2>
              <p className="vision-description">
                At fixINN, we're more than a service — we're your trusted local partner. We believe in doing things the right way: with heart, honesty, and a smile.
              </p>
              <ul className="vision-list">
                {visionPoints.map((point, index) => (
                  <li key={index} className="vision-list-item">
                    <img src={tickIcon} alt="tick" className="vision-tick" />
                    <span className="vision-point-text">{point}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurPromise;